var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcWallet24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 1 4.25 C 1.649 3.762 2.438 3.499 3.25 3.5 L 16.75 3.5 C 17.594 3.5 18.373 3.779 19 4.25 C 19 3.007 17.993 2 16.75 2 L 3.25 2 C 2.007 2 1 3.007 1 4.25 Z M 1 7.25 C 1.649 6.762 2.438 6.499 3.25 6.5 L 16.75 6.5 C 17.594 6.5 18.373 6.779 19 7.25 C 19 6.007 17.993 5 16.75 5 L 3.25 5 C 2.007 5 1 6.007 1 7.25 Z M 7 8 C 7.552 8 8 8.448 8 9 C 8 10.105 8.895 11 10 11 C 11.105 11 12 10.105 12 9 C 12 8.448 12.448 8 13 8 L 16.75 8 C 17.993 8 19 9.007 19 10.25 L 19 15.75 C 19 16.993 17.993 18 16.75 18 L 3.25 18 C 2.007 18 1 16.993 1 15.75 L 1 10.25 C 1 9.007 2.007 8 3.25 8 Z",
    fill: "hsl(0, 0%, 100%)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWallet24);
export default __webpack_public_path__ + "static/media/ic_wallet_24.30807ce8577fd25d59d4953b2240fd41.svg";
export { ForwardRef as ReactComponent };